import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//

import { getMerchantChannelBalance } from "@/api/merchant";
export default {
  name: "amout",
  data: function data() {
    return {
      channelBalance: []
    };
  },
  methods: {
    getChannelBalance: function getChannelBalance() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, totleBankName, i, obj, arr, bankName, j;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getMerchantChannelBalance();
            case 1:
              res = _context.sent;
              if (res.code === 0) {
                totleBankName = Object.keys(res.data.balanceList);
                for (i = 0; i < totleBankName.length; i++) {
                  console.log('totleBankName', totleBankName[i]);
                  obj = {};
                  arr = [];
                  bankName = Object.keys(res.data.balanceList[totleBankName[i]]);
                  obj.bankName = totleBankName[i];
                  for (j = 0; j < bankName.length; j++) {
                    arr.push(bankName[j] + ': ' + res.data.balanceList[totleBankName[i]][bankName[j]]);
                  }
                  obj.value = arr;
                  _this.channelBalance.push(obj);
                }
                console.log(_this.channelBalance);
              }
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return _this2.getChannelBalance();
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};